import { IconType } from "react-icons/lib";
import { TbUserCheck, TbUserX } from "react-icons/tb";

import { softColors } from "./colors";

export type UserDeletionStatusItem = {
    component: () => IconType;
    hover: string;
    bg: string;
    label: string;
    text: string;
    tooltip: {
        title: string;
        description: string;
    };
    value: boolean;
};

export type UserDeletionStatusList = UserDeletionStatusItem[];

export const userDeletionStatuses: UserDeletionStatusList = [
    {
        label: "Aktif",
        component: () => TbUserCheck,
        ...softColors.green,
        tooltip: {
            title: "Kullanıcı Durmu",
            description: "Kullanıcı mesai işlemlerinde normal görünecektir.Görev ataması kısmında görünecektir",
        },
        value: false,
    },
    {
        label: "Silindi",
        component: () => TbUserX,
        ...softColors.brown,
        tooltip: {
            title: "Kullanıcı iptal edildi",
            description: "Kullanıcı mesai işlemlerinde kırmızı görünecektir.Görev ataması kısmında görünmeyecektir.",
        },
        value: true,
    },
];
